export const environment = {
  production: true,
  host: 'tctalent-test.org',
  publishUrl: 'https://tctalent-test.org/published',
  apiUrl: 'https://tctalent-test.org/api/admin',
  chatApiUrl: 'https://tctalent-test.org/api/admin',
  halApiUrl: 'https://tctalent-test.org/api/hal',
  publicApiUrl: 'https://tctalent-test.org/api/public',
  systemApiUrl: 'https://tctalent-test.org/api/system',
  termsInfoApiUrl: 'https://tctalent-test.org/api/admin',
  s3BucketUrl: 'https://s3.us-east-1.amazonaws.com/files.tbbtalent.org',
  assetBaseUrl: '/admin-portal',
  environmentName: 'staging',
  clarityProjectId: 'pquy45i1um',
  presetWorkspaceId: '987e2e02',
  googleAnalyticsId: 'G-BPDYWB77Y3'
};
